var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
export var initialModalState = {
    show: false,
    saved: false,
    cancelled: false,
};
export var onShow = function (setState) {
    return setState({
        show: true,
        saved: false,
        cancelled: false,
    });
};
export var onSave = function (setState) {
    return setState({
        show: false,
        saved: true,
        cancelled: false,
    });
};
export var onCancel = function (setState) {
    return setState({
        show: false,
        saved: false,
        cancelled: true,
    });
};
export var GenericModal = function (_a) {
    var title = _a.title, show = _a.show, save = _a.save, cancel = _a.cancel, size = _a.size, modalProps = _a.modalProps, hideFooter = _a.hideFooter, primaryButtonLabel = _a.primaryButtonLabel, children = _a.children;
    var passThruProps = modalProps ? __assign({}, modalProps) : {};
    var sizeProp = passThruProps.dialogClassName ? {} : { size: size || "xl" };
    return (React.createElement(Modal, __assign({}, sizeProp, { show: show, onHide: cancel, enforceFocus: false, restoreFocus: false, scrollable: true }, passThruProps),
        title && (React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null, title),
            React.createElement(Button, { className: "close", variant: "light", onClick: cancel }, "\u00D7"))),
        React.createElement(Modal.Body, null,
            !title && (React.createElement(Button, { className: "close", variant: "light", onClick: cancel }, "\u00D7")),
            children),
        !hideFooter && (React.createElement(Modal.Footer, null,
            React.createElement(Button, { variant: "secondary", onClick: cancel }, "Cancel"),
            save && (React.createElement(Button, { variant: "primary", onClick: save }, primaryButtonLabel || "Save"))))));
};
//# sourceMappingURL=GenericModal.js.map